import * as BluetoothExceptions from '@amzn/ihm-associate-tools-js-lib'
// import { log } from 'console'

export const errorCodeToExceptionsMapping = Object.freeze({
    0: BluetoothExceptions.InvalidMacAddressException,
    1: BluetoothExceptions.BluetoothNotEnabledException,
    2: BluetoothExceptions.PairingCancelledException,
    3: BluetoothExceptions.PairingTimeoutException,
    4: BluetoothExceptions.PairingFailureException,
    5: BluetoothExceptions.DeviceFilteredException,
    6: BluetoothExceptions.ConnectionFailureException,
    7: BluetoothExceptions.BluetoothPrintFailureException,
    8: BluetoothExceptions.MissingArgumentsException,
    9: BluetoothExceptions.InvalidProfileException,
    10: BluetoothExceptions.InvalidActionException,
    11: BluetoothExceptions.FetchingUuidFailureException,
    12: BluetoothExceptions.BluetoothUnknownErrorException,
    13: BluetoothExceptions.DisconnectFailedException,
    14: BluetoothExceptions.InterruptedException,
    15: BluetoothExceptions.IncompleteDataReceivedException,
    16: BluetoothExceptions.UnsupportedCharsetException,
    17: BluetoothExceptions.InvalidArgsFormatException,
    18: BluetoothExceptions.UnsupportedGattEventException,
    19: BluetoothExceptions.BluetoothGattEventException,
})

export class CandyCaneBluetoothErrorMappings {

    /**
     *  Get exception by mapping with error code.
     * @param error     error with errorCode and errorMessage
     * @returns         exception mapped with error code.
     *                  If code is not found from the mapping, return BluetoothUnknownErrorException
     */
    public static getExceptionForError (error) {
        if (errorCodeToExceptionsMapping.hasOwnProperty(error.errorCode)) {
            console.error('Received error: ',error.errorMessage)
            return new errorCodeToExceptionsMapping[error.errorCode]({
                message: error.errorMessage,
            })
        }

        console.error('Unknown error ', error)
        return new BluetoothExceptions.BluetoothUnknownErrorException({
            message: error.errorMessage,
        })
    }
}
